export default __webpack_public_path__ + "static/media/Boxing_01.5306cb4e.png";